module.exports = __webpack_public_path__ + "img/LogoVertical.0ce509be.png";